'use client'

import NavbarDesktop from "@/components/navbar/navbarDesktop";
import NavbarMobile from "@/components/navbar/navbarMobile";
import { usePathname } from "next/navigation";

export default function Navbar() {
  const user = "User 101"
  const pathname = usePathname();

  // Don't show navbar on homepage
  if (pathname === '/') {
    return null;
  }

  return (
    <nav>
      <div className="hidden md:block bg-background fixed top-0 left-0 right-0 z-40 border-b shadow-sm p-2">
        <NavbarDesktop user={user} />
      </div>

      {/* Mobile Navigation - fixed at the bottom */}
      <div className="md:hidden bg-background fixed bottom-0 left-0 right-0 z-40 border-t p-2">
        <NavbarMobile user={user} />
      </div>

    </nav>
  );
}
